<ngx-loading [show]="loading || routeLoading" [config]="{ backdropBorderRadius: '8px', fullScreenBackdrop: true }"></ngx-loading>

<div class="mission-container">
  <div class="main-content">
    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Search Bar -->
      <div class="search-container" style="display: flex;justify-content: space-between">
        <div class="search-wrapper" style="width: 90%">
          <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
          <input type="search" class="search-input" placeholder="Rechercher une mission..." #searchTerm />
        </div>
        <button type="button" class="btn btn-primary btn-sm" (click)="openMissionForm()" style="width: 10%">
          <i style="color: white;" class="fa fa-plus-circle add" aria-hidden="true"></i>
        </button>
      </div>

      <!-- Mission List -->
      <div class="mission-list">
        <div *ngFor="let mission of missions | filterBy : {label: searchTerm.value}" class="mission-item"
          [class.active]="selectedMission?.id == mission.id" (click)="selectedMissionList(mission)">
          <div class="mission-content">
            <div class="mission-header">
              <h3 class="mission-title">{{ mission?.label }}</h3>
              <span class="mission-date">{{ mission?.createAt | date:'dd/MM/yy' }}</span>
            </div>
            <div class="mission-info">
              <span class="route-count">
                <svg class="info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7">
                  </path>
                </svg>
                {{ mission?.routeLegs?.length }} trajets
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-area">
      <app-leaflet [item]="'poi'" [hidebutton]="false"></app-leaflet>
      <div class="btn_colaps">
        <div class="btn-toggle btnOpenColap" (click)="isCollapsed = !isCollapsed"
          [title]="isCollapsed ? 'Afficher les détails' : 'Cacher les détails'">
          <i class="fa" [ngClass]="isCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"
            style="color: #053887; padding: 5px;"></i>
        </div>
      </div>

      <div class="mission-details-container" [ngClass]="{'collapsed': isCollapsed}"
        style="max-height: 500px; overflow-y: auto; transition: all 0.3s ease-in-out; scrollbar-width: none; -ms-overflow-style: none;">
        <div class="header" style="display: flex; justify-content: flex-end; align-items: center; padding: 0.5rem;">
          <div class="button-group">
            <button type="button" class="btn btn-edit" title="Excel Th" (click)="downloadExcel()">
              <i class="fa fa-download"></i>
            </button>
            <button type="button" class="btn btn-edit" title="Modifier" (click)="openMissionEditForm()">
              <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn btn-delete" title="Supprimer" (click)="onConfirmDelete()">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- Collapsible Content -->
        <div class="content-wrapper"
          style="transition: opacity 0.3s ease; margin-left: 0px !important;padding-top: 0px; top: 30px;">
          <div class="summary">
            <div class="summary-grid">
              <div class="maps-estime" type="button" (click)="drawRoute()">
                <img src="assets/icons/routing-api.svg" alt="Route Icon" class="route-icon" />
              </div>
              <div class="summary-item">
                <span class="summary-label">Date création:</span>
                <span class="summary-value">{{ selectedMission?.createAt | date: 'dd-MM-yy, HH:mm' }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Trajets:</span>
                <span class="summary-value">{{ selectedMission?.routeLegs?.length }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Départ:</span>
                <span class="summary-value bold">{{ selectedMission?.routeLegs[0]?.labelPOISource }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Arrivée:</span>
                <span class="summary-value bold">
                  {{ selectedMission?.routeLegs[selectedMission?.routeLegs?.length - 1]?.labelPOITarget }}
                </span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Distance:</span>
                <span class="summary-value">{{ (selectedMission?.travelDistance) | number: '.0-2' }} Km</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Durée:</span>
                <span class="summary-value">{{ selectedMission?.travelDuration | timediff }}</span>
              </div>
            </div>
          </div>

          <!-- Routes List -->
          <div class="routes">
            <h4>Trajets</h4>
            <div *ngIf="routeLoading" class="loading-container">
              <i class="fa fa-spinner fa-spin"></i> Chargement du trajet...
            </div>
            <div *ngFor="let route of selectedMission?.routeLegs; let i = index" class="route-item"
              [class.selected]="selectedRoute === route" (click)="drawRoutefille(route)">
              <div class="route-content">
                <div class="route-info">
                  <span class="route-number">Trajet {{ i + 1 }}:</span>
                  <span>{{ route?.labelPOISource }} → {{ route?.labelPOITarget }}</span>
                </div>
                <div class="route-details">
                  {{ (route?.travelDistance) | number:'1.2-2' }} Km | {{ route?.travelDuration | timediff }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- DashBord Modal -->
<div class="modal fade" tabindex="-1" #missionFormModal="bs-modal" bsModal role="dialog">
  <div class="modal-dialog modal-lg" style="-webkit-transform: translate(0, 0);">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="missionFormModalhide()">×</button>
        <h4 class="modal-title"><i class="fa fa-plus-circle" aria-hidden="true"></i> Nouvelle mission</h4>
      </div>
      <div class="modal-body">
        <div class="box-body">
          <app-mission-form [mode]="mode" [mission_]="missionForm"
            (missionSaved)="onMissionSaved($event)"></app-mission-form>
        </div>
      </div>
      <div class="box-footer">
        <button (click)="missionFormModalhide()" class="btn btn-default pull-right">
          Fermer
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<div class="modal fade" tabindex="-1" #missionDeleteModal="bs-modal" bsModal role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="missionDeleteModalhide()">×</button>
        <h4 class="modal-title">
          <i class="fa fa-cogs" aria-hidden="true"></i> Êtes-vous sûr ?
        </h4>
      </div>
      <div class="modal-body">
        <div class="alert alert-danger alert-dismissible" style="border-radius: 0px; text-align: center">
          <h4 style="color: white">
            <i class="fa fa-exclamation-triangle"></i> Suppression !
          </h4>
          <span>Êtes-vous sûr de supprimer la planification du camion ?</span>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="missionDeleteModalhide()">
          Annuler
        </button>
        <button type="button" class="btn btn-success" (click)="onDelete()">
          <i class="fa fa-check" aria-hidden="true" *ngIf="!loading"></i>
          <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Oui, Je confirme
        </button>
      </div>
    </div>
  </div>
</div>
